import { getRouteApi } from '@tanstack/react-router';

// Typed handles on the routes that pages and hooks read from. router.tsx imports
// those pages, so importing its route objects back would be a cycle; getRouteApi
// binds by route id instead and pulls in nothing from the router module. The ids
// are checked against the registered route tree, so a typo fails tsc.
//
// Each handle keeps the name of the route it stands for, so call sites read the
// same as before: storeLayout.useRouteContext(), orderEditRoute.useParams().

export const authenticatedLayout = getRouteApi('/authenticated');
export const storeLayout = getRouteApi('/authenticated/stores/$storeId');
export const vendorEditRoute = getRouteApi('/authenticated/stores/$storeId/vendors/$vendorId/edit');
export const orderEditRoute = getRouteApi(
  '/authenticated/stores/$storeId/orderLayout/orders/$orderId/edit'
);
export const orderSummaryRoute = getRouteApi(
  '/authenticated/stores/$storeId/orderLayout/orders/$orderId/summary'
);
export const orderCleanupRoute = getRouteApi(
  '/authenticated/stores/$storeId/orderLayout/orders/cleanup'
);
export const receivingSessionRoute = getRouteApi(
  '/authenticated/stores/$storeId/receiving/$sessionId'
);
export const productReportsLayout = getRouteApi(
  '/authenticated/stores/$storeId/reports/productReportsLayout'
);
export const exceptionLogsRoute = getRouteApi(
  '/authenticated/stores/$storeId/reports/productReportsLayout/exception-logs'
);
export const salesJournalRoute = getRouteApi(
  '/authenticated/stores/$storeId/reports/sales-journal'
);
export const onboardingTimelineRoute = getRouteApi('/authenticated/admin/onboarding/$storeId');
